import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const DischargedBadge: FC = () => {
  const { t } = useTranslation(['component']);

  return (
    <Badge className="border-transparent bg-secondary text-secondary-foreground">
      {t('component:badge.discharged')}
    </Badge>
  );
};
